import React, {Component} from 'react';
import styles from './IndexPage.scss';
import querystring from 'query-string';

import {browserHistory} from 'react-router';
import HowItWorks from './sections/HowItWorks';
import OurCustomers from './sections/OurCustomers';
import FeaturesSection from './sections/FeaturesSection';
import LinkButton from '../controls/buttons/LinkButton';

export default class IndexPage extends Component {
    componentDidMount() {
        const resetToken = this.getResetToken();
        const inviteToken = this.getInviteToken();

        if (resetToken || inviteToken){
            const {search} = browserHistory.getCurrentLocation();
            window.location = `https://app.cirrusmed.com/${search}`;
        }

        this.jumpToHash();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hashKey !== this.props.hashKey)
            this.jumpToHash();
    }

    jumpToHash() {
        const hash = browserHistory.getCurrentLocation().hash;
        const element = hash.slice(1);

        if (!hash) return;

        if (this.refs[element])
            setTimeout(
                () =>
                    this.refs[element].scrollIntoView({block: 'start', behavior: 'smooth'}),
                50); // Use timeout to avoid bug with react-router
    };

    getResetToken = () => {
        const {search} = browserHistory.getCurrentLocation();
        const parsed = querystring.parse(search);
        return parsed.resetToken;
    };

    getInviteToken = () => {
        const {search} = browserHistory.getCurrentLocation();
        const parsed = querystring.parse(search);
        return parsed.inviteToken;
    };

    render() {
        return (
            <div className={styles.wrapperIndexPage}>
                {this.renderHeader()}
                <div className={styles.landing}>
                    <div className={styles.wrapSection}>
                        <HowItWorks openSection={this.openSection} />
                    </div>
                    <div ref='how-it-works' className={styles.wrapSection}>
                        <FeaturesSection />
                    </div>
                    <div ref='our-customers' id='our-customers' className={styles.wrapSection}>
                        <OurCustomers />
                    </div>
                </div>
            </div>
        );
    }

    renderHeader() {
        return (
            <div ref='header' className={styles.header}>
                <picture className={styles.image}>
                    <source type="image/webp" className={styles.picture} srcSet='static/images/header.webp 1x,
                                                  static/images/header@2x.webp 2x'/>
                    <img className={styles.picture} srcSet="static/images/header.png 1x,
                             static/images/header@2x.png 2x"/>
                </picture>
                <div className={styles.headerTitleWrapper}>
                    <h1 className={styles.headerTitle}>
                        {loc('header-title')}.
                </h1>
                    <LinkButton
                        to='https://app.cirrusmed.com/doctors'
                        label={loc('choose-doctor-label')}
                        className={styles.chooseDocBtn}
                        isExternal
                    />
                </div>
            </div>
        );
    }

    openSection = (section) => {
        const {onActivateLandingSection} = this.props;
        onActivateLandingSection && onActivateLandingSection(section);
    };
}



// WEBPACK FOOTER //
// ./src/components/Index/IndexPage.js